module.exports = __webpack_public_path__ + "img/handle-ban.b7e4db68.png";